import React from "react";
import { Paper as MUIPaper, styled } from "@mui/material";
import { PaperProps } from "@mui/material/Paper/Paper";

export const TitleCardContent = styled(
  MUIPaper,
  {}
)<PaperProps>(({ theme }) => ({
  borderRadius: "2px",
  boxShadow: "2px",
})) as React.ComponentType<PaperProps>;
